// import Particles from 'react-particles-js';
import React from "react"
import Img from "gatsby-image"
import { useStaticQuery, graphql } from "gatsby"
import './../css/background.css'

export default function Background() {

  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "assets/background.png" }) {
        childImageSharp {
          fixed(width: 2048, height: 2732) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)
  return <Img className = 'background' fixed={data.file.childImageSharp.fixed} />

}
